import { render, staticRenderFns } from "./ServiceDevices.vue?vue&type=template&id=f8fe0b82&scoped=true&"
import script from "./ServiceDevices.vue?vue&type=script&lang=js&"
export * from "./ServiceDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fe0b82",
  null
  
)

export default component.exports